import {useTranslation} from 'react-i18next';
import {Box, Typography} from '@mui/material';
import {CheckRounded, PriorityHighRounded} from '@mui/icons-material';
import {translations} from '../../../../../i18n/translations';
import {OccurrenceStatus as OccurrenceStatusValue} from './occurrences.professional-caregiver.screen';

type OccurrenceStatusProps = {
  status: OccurrenceStatusValue;
};

export const OccurrenceStatus = ({status}: OccurrenceStatusProps) => {
  const {t} = useTranslation();
  const label = t(translations.office.professional_caregiver.occurrences.status[status]);

  const Icon = () => {
    switch (status) {
      case 'not_handled':
        return <PriorityHighRounded />;
      case 'handled':
        return <CheckRounded />;

      default:
        return <></>;
    }
  };

  return (
    <Box
      className={`care-table-row-cell care-table-row-cell-status-${status === 'not_handled' ? 'missed' : status === 'handled' ? 'done' : ''}`}
    >
      {(status === 'not_handled' || status === 'handled') && (
        <Box
          className="care-table-row-cell-status-icon"
          sx={{
            '> svg': {
              height: '16px',
              width: '16px',
            },
          }}
        >
          <Icon />
        </Box>
      )}
      {window.innerWidth > 430 && (
        <Typography className="care-table-row-cell-status-label">{label}</Typography>
      )}
    </Box>
  );
};
